import styled from 'styled-components';

type MatrixCheckBoxProps = {
  brandColor?: string;
};

export const StyledMatrix = styled.div`
  overflow: auto;
  max-height: 512px;
  scroll-behavior: smooth;
  margin: 12px 0;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #ebeff3;
  }
  table.st-mt-table,
  th.st-mt-th,
  td.st-mt-td,
  tr.st-mt-tr {
    padding: 0;
    margin: 0;
  }
  table.st-mt-table {
    border-spacing: 0;
    border-radius: 4px;
    color: var(--base-color);
    font-size: 14px;
    font-weight: 400;
  }
  th.st-mt-th {
    color: #12344d;
    text-align: center;
    padding: 12px 24px;
    background-color: white;
  }
  th.m-s-b-s-q-m-s-th-empty {
    z-index: 2;
    position: sticky;
    top: 0;
    left: 0;
    background-color: white;
    border: 1px solid rgb(242, 242, 242);
  }
  th.m-s-b-s-q-m-s-th {
    border-right: 1px solid rgb(242, 242, 242);
    border-top: 1px solid rgb(242, 242, 242);
    border-bottom: 1px solid rgb(242, 242, 242);
    z-index: 1;
    position: sticky;
    top: 0;
    button.cl-minus {
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      display: none;
    }
    button.cl-plus {
      top: 50%;
      right: 0;
      transform: translate(50%, -50%);
    }
  }
  th.m-s-b-s-q-m-s-input,
  td.m-s-b-s-q-m-s-input {
    position: sticky;
    left: 0;
    z-index: 1;
    background-color: white;
    padding: 12px;
  }
  td.m-s-b-s-q-m-s-input {
    border-right: 1px solid rgb(242, 242, 242);
    border-bottom: 1px solid rgb(242, 242, 242);
    border-left: 1px solid rgb(242, 242, 242);
    min-width: 220px;
    max-width: 400px;
  }
  th.m-s-b-s-q-m-s-th:focus-within,
  th.m-s-b-s-q-m-s-th:hover {
    button.cl-minus {
      display: grid;
    }
  }
  td.m-s-b-s-q-m-s-input {
    button.cl-minus {
      top: 50%;
      left: 0;
      transform: translate(-50%, -50%);
      display: none;
    }
    button.cl-plus {
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
    }
  }
  td.m-s-b-s-q-m-s-switch {
    text-align: center;
    padding: 12px 24px;
    min-width: 100px;
    border-bottom: 1px solid rgb(242, 242, 242);
    border-right: 1px solid rgb(242, 242, 242);
    .radio,
    .checkbox {
      margin-right: unset;
      line-height: normal;
    }
    .checkbox span {
      top: 3px;
    }
    div:first-child {
      width: fit-content;
      margin: 0 auto;
    }
  }
  td.m-s-b-s-q-m-s-input:focus-within,
  td.m-s-b-s-q-m-s-input:hover {
    button.cl-minus {
      display: grid;
    }
  }
`;

export const MatrixCheckBox = styled.div<MatrixCheckBoxProps>`
  .checkbox {
    background: ${({ brandColor }) => brandColor};
    pointer-events: none;
  }
`;
